// ----- Phase phase-ui-consistency-sweep (§3E) — Dashboard "Next step" -----
//
// The Dashboard "Next Step" column was almost entirely empty. This helper
// maps a submission's status to the actual next action the user should
// take, so the column tells the user what to do next at a glance.

import type { StatusEvidence } from '@/hooks/useStatusEvidence';
import { statusEvidenceDisplay } from '@/lib/statusEvidence';
import { normalizeStatus, type CanonicalStatus } from '@/constants/status';

/**
 * Plain-English next action for a submission, driven by its status.
 * Returns `null` when there is no actionable next step (so callers can
 * choose to render nothing rather than a meaningless label).
 */
export function nextStepFor(status: string | null | undefined, evidence?: StatusEvidence): string | null {
  if (evidence) return statusEvidenceDisplay(evidence).nextStep;
  const normalized = normalizeStatus(status) as CanonicalStatus;
  switch (normalized) {
    case 'Draft':
      return 'Upload documents';
    case 'Classify':
    case 'Classifying':
      return 'Review placements';
    case 'Confirm':
      return 'Review placements';
    case 'Ready':
      return 'Validate and compile';
    case 'Processing':
      return 'Compiling…';
    case 'Submitted':
    case 'Approved':
    case 'Rejected':
    case 'Complete':
      return 'View submission';
    case 'Failed':
      return 'Review errors';
    default:
      return 'Open';
  }
}
